document.addEventListener('click', event => {
  const button = event.target.closest('[data-quantity-step]');
  if (!button) return;
  const input = button.parentElement.querySelector('input[type="number"]');
  if (!input) return;
  const step = Number(input.step) || 1;
  const minimum = Number(input.min) || 0;
  const maximum = input.max === '' ? Infinity : Number(input.max);
  const value = Math.min(maximum, Math.max(minimum, (Number(input.value) || minimum) + Number(button.dataset.quantityStep) * step));
  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
const skuInput = document.querySelector('[data-contact-sku]');
if (skuInput) skuInput.value = new URLSearchParams(window.location.search).get('sku') || '';
if (window.matchMedia('(max-width: 767px)').matches) {
  document.querySelectorAll('.hp-filter-shell').forEach(shell => shell.removeAttribute('open'));
}
